import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Smartphone, CreditCard } from 'lucide-react';
import { PdfMockup } from './PdfMockup';
export function Hero() {
  return <section className="relative pt-12 pb-16 md:pt-20 md:pb-24 px-5 overflow-hidden" data-id="element-58">
      <div className="max-w-5xl mx-auto" data-id="element-59">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-60">
          {/* Text Content */}
          <motion.div className="flex flex-col z-10" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-61">
            <div className="inline-flex items-center space-x-2 bg-surface border border-rose/30 px-3 py-1.5 rounded-full w-fit mb-6" data-id="element-62">
              <span className="w-2 h-2 rounded-full bg-terracotta animate-pulse" data-id="element-63" />
              <span className="text-xs font-semibold text-heading uppercase tracking-wider" data-id="element-64">
                Guía PDF · GuiaDownload.com
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-semibold leading-[1.1] mb-5 text-heading" data-id="element-65">
              Ayuda a tu bebé a dormir mejor sin métodos extremos ni consejos
              confusos
            </h1>

            <p className="text-lg md:text-xl text-body mb-8 leading-relaxed" data-id="element-66">
              Rutinas simples por edad para mamás latinas agotadas que necesitan
              un plan claro hoy.
            </p>

            {/* Mobile Mockup Placement */}
            <div className="md:hidden w-full py-6 mb-4" data-id="element-67">
              <PdfMockup data-id="element-68" />
            </div>

            <ul className="space-y-3 mb-8" data-id="element-69">
              {['Rutinas por edad fáciles de seguir', 'Qué hacer en siestas y despertares', 'Menos caos, más calma en casa'].map((bullet, i) => <motion.li key={i} className="flex items-start space-x-3" initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.3 + i * 0.1
            }} data-id="element-70">
                  <CheckCircle2 className="w-5 h-5 text-terracotta shrink-0 mt-0.5" data-id="element-71" />
                  <span className="text-heading font-medium" data-id="element-72">{bullet}</span>
                </motion.li>)}
            </ul>

            <div className="flex flex-col space-y-4" data-id="element-73">
              <div className="flex items-baseline space-x-3" data-id="element-74">
                <span className="text-3xl font-serif font-bold text-heading" data-id="element-75">
                  Hoy por solo $8.39
                </span>
                <span className="text-lg text-body line-through decoration-rose/60" data-id="element-76">
                  $17
                </span>
              </div>

              <a href="#comprar" onClick={e => {
              e.preventDefault();
              document.getElementById('comprar')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }} className="group relative inline-flex items-center justify-center w-full md:w-auto px-8 py-4 bg-terracotta text-white rounded-full font-semibold text-lg transition-all hover:bg-terracotta-dark hover:scale-[1.02] active:scale-[0.98] shadow-lg shadow-terracotta/20" data-id="element-77">
                Quiero la guía →
              </a>

              <div className="flex flex-wrap items-center justify-center md:justify-start gap-x-4 gap-y-2 text-xs text-body font-medium mt-2" data-id="element-78">
                <span className="flex items-center" data-id="element-79">
                  <ShieldCheck className="w-3.5 h-3.5 mr-1 text-terracotta" data-id="element-80" />{' '}
                  Compra segura
                </span>
                <span className="flex items-center" data-id="element-81">
                  <Smartphone className="w-3.5 h-3.5 mr-1 text-terracotta" data-id="element-82" />{' '}
                  Acceso digital
                </span>
                <span className="flex items-center" data-id="element-83">
                  <CreditCard className="w-3.5 h-3.5 mr-1 text-terracotta" data-id="element-84" />{' '}
                  Pago en Shopify
                </span>
              </div>
            </div>
          </motion.div>

          {/* Desktop Mockup Placement */}
          <div className="hidden md:block w-full relative" data-id="element-85">
            <PdfMockup data-id="element-86" />
          </div>
        </div>
      </div>
    </section>;
}